import { render, staticRenderFns } from "./SIconComposer.vue?vue&type=template&id=3b8f1d7a&scoped=true&lang=pug"
import script from "./SIconComposer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SIconComposer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SIconComposer.vue?vue&type=style&index=0&id=3b8f1d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f1d7a",
  null
  
)

export default component.exports